import { Button } from '@/shared/ui/Button';
import { AlertIcon } from '@/shared/ui/icons';

interface ErrorStateProps {
  title?: string;
  message: string;
  onRetry?: () => void;
}

export function ErrorState({ title = 'Não foi possível carregar', message, onRetry }: ErrorStateProps) {
  return (
    <div role="alert" className="flex flex-col items-center justify-center gap-3 px-6 py-16 text-center">
      <span className="flex size-12 items-center justify-center rounded-full bg-rejected-soft text-rejected [&>svg]:size-6" aria-hidden="true">
        <AlertIcon />
      </span>
      <div className="space-y-1">
        <h2 className="text-[0.9375rem] font-semibold text-ink">{title}</h2>
        <p className="max-w-sm text-sm text-ink-muted">{message}</p>
      </div>
      {onRetry ? (
        <Button variant="secondary" size="sm" onClick={onRetry}>
          Tentar novamente
        </Button>
      ) : null}
    </div>
  );
}
